// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_page__BEOOd {
  padding: 12px 16px 100px 16px;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background: rgb(247, 246, 255);
  text-align: center;
  color: rgb(255, 255, 255);
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
}

.style_section__\\+tyDd {
  padding: 2px;
  border-radius: 10px;
  width: 100%;
  max-width: 350px;
}

.style_content__Fe7-j {
  display: flex;
  justify-content: space-between;
  background: rgb(255, 255, 255);
  align-items: center;
  border-radius: 10px;
  padding: 12px 20px;
  gap: 8px;
}
.style_content__title__vwDzg {
  color: rgb(27, 27, 27);
  font-weight: 700;
  font-size: 2.4rem;
  max-width: 100px;
}
.style_content__description__meDtD {
  color: rgb(213, 212, 220);
  font-size: 1.4rem;
  font-weight: 500;
  margin: 16px 0;
  text-align: center;
}
.style_content__text__L2CMR {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.style_content__text__week__BxkQe {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  color: rgb(27, 27, 27);
  text-transform: uppercase;
}
.style_content__text__block__4oGab {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
}
.style_content__text__block__4oGab p {
  color: rgb(27, 27, 27);
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 14px;
}
.style_content__text__block__4oGab h4 {
  color: rgb(27, 27, 27);
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 28px;
}

.style_clan__VfyON {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
}
.style_clan__image__Z-V2i {
  width: 80px;
  height: 80px;
}
.style_clan__image__Z-V2i img {
  width: 100%;
  height: 100%;
}
.style_clan__title__Grmtj {
  font-weight: 700;
  color: rgb(27, 27, 27);
  font-size: 2.4rem;
}
.style_clan__members__5-t\\+H {
  color: rgb(27, 27, 27);
  font-size: 1.6rem;
}
.style_clan__members__5-t\\+H i {
  margin-right: 4px;
}

.style_divider__\\+gOVL {
  height: 2px;
  width: 100%;
  background: linear-gradient(90deg, rgba(117, 83, 240, 0) 0%, rgba(117, 83, 240, 0.1) 49.5%, rgba(117, 83, 240, 0) 100%);
}

.style_leave__migz3 {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  border: 1px solid rgb(225, 225, 225);
  border-radius: 10px;
  position: absolute;
  top: 15px;
  right: 15px;
}
.style_leave__migz3 i {
  color: rgb(135, 135, 135);
}
.style_leave__text__3GAkb {
  color: rgb(135, 135, 135);
  font-size: 1.2rem;
  font-weight: 700;
}
.style_leave__content__DRUd6 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.style_leave__time__ErGJO {
  width: 100%;
  text-align: center;
  color: rgb(135, 135, 135);
  font-weight: 400;
  font-size: 1.2rem;
}

.style_popover__image__UCsdH {
  margin-top: 32px;
  width: 120px;
  height: 120px;
}
.style_popover__image__UCsdH img {
  width: 100%;
  height: 100%;
}

.style_popover__actions__Ed\\+YF {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-top: 24px;
}

.style_popover__text__limitation__MCst6 {
  max-width: 280px;
}`, "",{"version":3,"sources":["webpack://./src/features/clans/clan/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBCJM;EDKN,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,8BCvBM;EDwBN,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AADF;AAEE;EACE,sBChCU;EDiCV,gBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,yBClCS;EDmCT,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBCtDQ;EDuDR,yBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AADN;AAEM;EACE,sBChEM;EDiEN,gBAAA;EACA,iBAAA;EACA,iBAAA;AAAR;AAEM;EACE,sBCtEM;EDuEN,gBAAA;EACA,iBAAA;EACA,iBAAA;AAAR;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAIE;EACE,gBAAA;EACA,sBC/FU;EDgGV,iBAAA;AAFJ;AAIE;EACE,sBCnGU;EDoGV,iBAAA;AAFJ;AAGI;EACE,iBAAA;AADN;;AAMA;EACE,WAAA;EACA,WAAA;EACA,uHAAA;AAHF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EASA,kBAAA;EACA,SAAA;EACA,WAAA;AAhBF;AAME;EACE,yBC7HQ;ADyHZ;AAME;EACE,yBChIQ;EDiIR,iBAAA;EACA,gBAAA;AAJJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARJ;AAUE;EACE,WAAA;EACA,kBAAA;EACA,yBChJQ;EDiJR,gBAAA;EACA,iBAAA;AARJ;;AAYA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;AATF;AAUE;EACE,WAAA;EACA,YAAA;AARJ;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AATF;;AAYA;EACE,gBAAA;AATF","sourcesContent":["@import '../../../../public/assets/colors';\n\n.page {\n  padding: 12px 16px 100px 16px;\n  width: 100vw;\n  height: 100vh;\n  overflow-y: auto;\n  background: rgba(247, 246, 255, 1);\n  text-align: center;\n  color: $white;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  position: relative;\n}\n\n.section {\n  padding: 2px;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 350px;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  background: $white;\n  align-items: center;\n  border-radius: 10px;\n  padding: 12px 20px;\n  gap: 8px;\n  &__title {\n    color: $black-extra;\n    font-weight: 700;\n    font-size: 2.4rem;\n    max-width: 100px;\n  }\n  &__description {\n    color: $light-grey;\n    font-size: 1.4rem;\n    font-weight: 500;\n    margin: 16px 0;\n    text-align: center;\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    &__week {\n      font-size: 1.4rem;\n      font-weight: 700;\n      line-height: 14px;\n      text-align: center;\n      color: $black-extra;\n      text-transform: uppercase;\n    }\n\n    &__block {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      align-items: center;\n      p {\n        color: $black-extra;\n        font-weight: 500;\n        font-size: 1.4rem;\n        line-height: 14px;\n      }\n      h4 {\n        color: $black-extra;\n        font-weight: 700;\n        font-size: 2.4rem;\n        line-height: 28px;\n      }\n    }\n  }\n}\n\n.clan {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  &__image {\n    width: 80px;\n    height: 80px;\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  &__title {\n    font-weight: 700;\n    color: $black-extra;\n    font-size: 2.4rem;\n  }\n  &__members {\n    color: $black-extra;\n    font-size: 1.6rem;\n    i {\n      margin-right: 4px;\n    }\n  }\n}\n\n.divider {\n  height: 2px;\n  width: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(117, 83, 240, 0) 0%,\n    rgba(117, 83, 240, 0.1) 49.5%,\n    rgba(117, 83, 240, 0) 100%\n  );\n}\n\n.leave {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 8px;\n  border: 1px solid rgba(225, 225, 225, 1);\n  border-radius: 10px;\n  i {\n    color: $dark-grey;\n  }\n  &__text {\n    color: $dark-grey;\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n  position: absolute;\n  top: 15px;\n  right: 15px;\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n  &__time {\n    width: 100%;\n    text-align: center;\n    color: $dark-grey;\n    font-weight: 400;\n    font-size: 1.2rem;\n  }\n}\n\n.popover__image {\n  margin-top: 32px;\n  width: 120px;\n  height: 120px;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.popover__actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  margin-top: 24px;\n}\n\n.popover__text__limitation {\n  max-width: 280px;\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `style_page__BEOOd`,
	"section": `style_section__+tyDd`,
	"content": `style_content__Fe7-j`,
	"content__title": `style_content__title__vwDzg`,
	"content__description": `style_content__description__meDtD`,
	"content__text": `style_content__text__L2CMR`,
	"content__text__week": `style_content__text__week__BxkQe`,
	"content__text__block": `style_content__text__block__4oGab`,
	"clan": `style_clan__VfyON`,
	"clan__image": `style_clan__image__Z-V2i`,
	"clan__title": `style_clan__title__Grmtj`,
	"clan__members": `style_clan__members__5-t+H`,
	"divider": `style_divider__+gOVL`,
	"leave": `style_leave__migz3`,
	"leave__text": `style_leave__text__3GAkb`,
	"leave__content": `style_leave__content__DRUd6`,
	"leave__time": `style_leave__time__ErGJO`,
	"popover__image": `style_popover__image__UCsdH`,
	"popover__actions": `style_popover__actions__Ed+YF`,
	"popover__text__limitation": `style_popover__text__limitation__MCst6`
};
export default ___CSS_LOADER_EXPORT___;
